import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { LeaderboardTable } from 'modules/monitoring/gamification/leaderboard_table_original';
import AppData from 'app_data';
import Utils from 'utils/common_utils';
import { ControlsActions } from 'actions/controls_actions';
import { Collapse } from 'components';
import GamificationControls from 'modules/monitoring/gamification/gamification_controls';
import { useScopedLocationIds } from 'hooks/useAdminGroup/useScopedLocationIds';
import LocationScopeGate from 'hooks/useAdminGroup/LocationScopeGate';

const mapStateToProps = (state) => ({
  controlsState: state.controls.gamification || {},
});

const mapDispatchToProps = (dispatch) => ({
  controlsActions: bindActionCreators(ControlsActions, dispatch),
});

class LeaderboardTablePopout extends Component {
  static propTypes = {
    controlsState: PropTypes.object,
    controlsActions: PropTypes.object,
    match: PropTypes.object,
    scopeApplyScope: PropTypes.bool,
    scopeExternalIds: PropTypes.instanceOf(Set),
  };

  state = {};

  componentWillMount() {
    const { id } = this.props.match.params;

    AppData.getPopoutParams(id).then((response) => {
      const { data } = response;
      this.props.controlsActions.loadState('gamification', data.controlsState);
      this.setState(data.componentState);
    });
  }

  render() {
    if (!this.state.displayType) {
      // settings call hasn't returned
      return <div />;
    }

    const { controlsState } = this.props;

    return (
      <div className="content-box monitoring-gamification">
        <div className="content-box-header">
          <Collapse>
            <GamificationControls
              disableBoardControls
            />
          </Collapse>
          <ul className="labels">
            <li>{controlsState.callType.label}</li>
            <li>{Utils.labelByUnit(this.state.displayType)}</li>
          </ul>
        </div>
        <div className="content-box-content">
          <LeaderboardTable
            realTime={controlsState.realTime}
            displayType={this.state.displayType}
            callType={controlsState.callType}
            timeRange={controlsState.timeRange}
            filterType={controlsState.filterType}
            filters={controlsState.filters}
            nBuckets={controlsState.boardType.nBuckets}
            grouping={controlsState.grouping}
            scopeApplyScope={this.props.scopeApplyScope}
            scopeExternalIds={this.props.scopeExternalIds}
          />
        </div>
      </div>
    );
  }
}

const ConnectedLeaderboardTablePopout = connect(mapStateToProps, mapDispatchToProps)(LeaderboardTablePopout);

// The popout opens in its own window, which shares localStorage with the app,
// so it resolves the breadcrumb scope itself instead of trusting whatever was
// serialized into the saved popout params (Sets don't survive JSON anyway).
const LeaderboardTablePopoutWithScope = (props) => {
  const scope = useScopedLocationIds();

  return (
    <LocationScopeGate scope={scope}>
      <ConnectedLeaderboardTablePopout
        {...props}
        scopeApplyScope={scope.applyScope}
        scopeExternalIds={scope.scopeExternalIds}
      />
    </LocationScopeGate>
  );
};

export default LeaderboardTablePopoutWithScope;
